<div id="customPopup" class="modal">
  <div class="modal-content modal-content-40">
    <div class="modal-main-content">
      <button class="close delete-close"><img src="/assets/images/close_circle.svg" id="closeButton" alt="Close"></button>
      <h2 class="popup-message center" id="popup-content-text">Are you sure you want to delete the user?</h2>
      <div class="button-container button-container-center">
        <button class="modal-button delete-close" id="cancelButton">Cancel</button>
        <button class="modal-button yes-button" id="deleteButton">Yes</button>
      </div>
    </div>
  </div>
</div>

<div class="dashboard-page">

  <div class="container">

    <div class="dashboard-section">
      <div class="dashboard-section-title">
        <h2 class="heading-level-2 blue-color mt-0">Find User</h2>
      </div>
      <div class="row">
        <div class="col-lg-12 col-sm-12 col-xs-12 override-width table-overflow">
          <div class="ag-theme-quartz">
          <ag-grid-angular #agGrid [gridOptions]="gridOptions" style="width: 100%; height: 630px"
            (gridReady)="onGridReady($event)" (filterModified)="onFilterModified()" class="ag-theme-material ag-theme-quartz ag-table mt-10"
            [columnDefs]="columnDefs" [context]="context" [frameworkComponents]="frameworkComponents">
          </ag-grid-angular>
        </div>
        </div>
        <div class="col-lg-12 col-sm-12">
          <a href="javascript:void(0)" (click)="navigateTiAdminHomePage()"
            class="go-back-button pull-right"><img class="go-back-icon" src="assets/images/active_down_arrow.svg" alt=""/>Back</a>
        </div>
      </div>
    </div>



  </div>
</div>

<span id="reset_password_popup_link" title="reset_password" aria-label="reset_password" data-bs-toggle="modal" data-bs-target="#myResetModal" class="hide-content"></span>

<div class="modal" title="reset_password" aria-label="reset_password" id="myResetModal" role="dialog">
  <div class="modal-dialog">
  <div class="modal-content modal-content-30">
    <div class="modal-header mb-0 pb-0">
      <span class="close" data-bs-dismiss="modal"><img src="/assets/images/close_circle.svg" alt="Close"></span>
      <h2 class="modal-heading center">Reset Password</h2>
    </div>
    <div class="modal-main-content">
      <form class="form-style1 reset_password_form mb-0" #userForm="ngForm" (ngSubmit)="resetPassword(userForm)"
        novalidate>
        <div class="form-group mb-20">
            <input title="email" aria-label="email" type="email" required name="email" [readonly]="true" [(ngModel)]="user.email" />
            <label>Email</label>
          </div>
        <div class="form-group mb-20">
            <input  title="password" aria-label="password" type="password" required name="newPassword" [(ngModel)]="user.newPassword"
              id="newPassword" placeholder=""/>
              <label>Enter Password</label>
            <img class="icon ml-5 reset_eye_img" alt="newPassword_img" src="assets/images/eye_password.svg" id="newPassword_img" tabindex="0"
              (click)="revealPassword('newPassword', 'newPassword_img')" />
        </div>
        <div class="form-group mb-20">
            <input title="password" aria-label="password" type="password" required name="confPassword" [(ngModel)]="user.confPassword"
              id="confPassword" placeholder=""/>
              <label>Confirm Password</label>
            <img class="icon ml-5 reset_eye_img" alt="confPassword_img" src="assets/images/eye_password.svg" id="confPassword_img" tabindex="0"
              (click)="revealPassword('confPassword', 'confPassword_img')" />
        </div>
        <p class="pwd_hint full-width">
          Your password cannot contain your email address, first name, or
          last name. It must be minimum of 8 characters in length,
          containing at least one upper case letter, one lower case letter,
          one number, and one special character.
        </p>
        <div class="button-container button-container-center">
          <button id="resetCancel" (click)="clearfields()" class="modal-button delete-close" data-bs-dismiss="modal">
            Cancel
          </button>
          <button type="submit" class="modal-button yes-button">
            Submit
          </button>
          <div *ngIf="errorMsg" class="errormsg" role="alert">
            {{ errorMsg }}
          </div>
        </div>
      </form>
    </div>
  </div>
  </div>
</div>
<!-- <ngui-popup #popup></ngui-popup> -->